import type { VotingPlace } from '@/types/votingPlace'

interface Props {
  recinto: VotingPlace
  selected: boolean
  onSelect: () => void
}

export function VotingPlaceListItem({ recinto, selected, onSelect }: Props) {
  return (
    <button
      className="voting-list-item"
      type="button"
      data-selected={selected}
      aria-pressed={selected}
      onClick={onSelect}
    >
      <span>
        <strong>{recinto.nombre}</strong>
        <small>Zona: {recinto.ubicacion.zona.nombre ?? 'Sin zona'}</small>
      </span>
      <b aria-hidden="true">›</b>
    </button>
  )
}
